export default {
    list: {
        title: "Portefeuilles vendeurs",
        name: 'balances',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: false,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: false,
                method: false,
                link: false,
                name: "Actions",
                buttons: [],
            }
        },
        columns: [
            {
                name: "id",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "id",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "seller",
                class: "text-left",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold text-gray-700",
                                    icone: "contacts"
                                },
                                {
                                    name: "email",
                                    class: "font-light text-gray-700",
                                    icone: "email"
                                },
                                {
                                    name: "type",
                                    class: "font-light text-gray-700",
                                    icone: "business"
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Solde",
                class: "font-bold",
                elements: [{
                    items: [{
                        class: "font-bold text-green-700",
                        name: "displayAmount",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Total reçu",
                class: "",
                elements: [{
                    items: [{
                        class: "text-gray-600",
                        name: "displayTotalAll",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "defaultCurrency",
                class: "",
                elements: [{
                    items: [{
                        class: "uppercase",
                        name: "defaultCurrency",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "updatedAt",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "updatedAt",
                        type: "text",
                    }],
                }, ]
            },
        ],
        actions: {
            name: "actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "format_list_bulleted",
                    color: "primary",
                    key: 'walletView',
                    id: "",
                    role: true,
                    tooltip: "Transactions",
                },
                {
                    icone: "add_circle",
                    color: "success",
                    key: 'deposit',
                    id: "",
                    role: true,
                    tooltip: "Deposit",
                },
                {
                    icone: "remove_circle",
                    color: "danger",
                    key: 'withdraw',
                    id: "",
                    role: true,
                    tooltip: "Withdraw",
                },
            ],
        },
        filters: {
            name: 'balances',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "search seller",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [{
                        label: "currency",
                        key: "defaultCurrency",
                        value: null,
                        values: ['MAD', 'USD'],
                        class: 'py-2 text-xs uppercase px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                ],
            },
        },
    },
}
